import { Button } from '@/components/ui/button';

type ActionButton = {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
};

interface ActionToastProps {
  actionButtons: ActionButton[];
}

export function ActionToast({ actionButtons }: ActionToastProps) {
  return (
    <div className="bg-fx-neutral-900/75 fixed bottom-10 left-1/2 -translate-x-1/2 rounded-lg px-4 py-2 shadow-lg">
      {actionButtons.map(button => {
        const Icon = button.icon;

        return (
          <Button
            key={button.label}
            variant="toast"
            size="sm"
            onClick={button.onClick}
          >
            {Icon}
            {button.label}
          </Button>
        );
      })}
    </div>
  );
}
